

export function getFeatureInfoByFeatureInfoKey(featureKey, featureInfoKey) {
    return window.attributeItems[featureKey][featureInfoKey].featureInfo
}

export function getAttributeItemByFeatureInfo(featureInfo) {
    return featureInfo.records[0].attributes[0][0]
}
